"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionsGuard = void 0;
const react_1 = require("react");
require("@veeam/core");
const context_1 = require("../context");
const usePermissionsGuard = () => {
    const { guard } = react_1.useContext(context_1.PermissionsGuardContext);
    return {
        canAction: (resourceName, action) => {
            return guard.can(resourceName, action);
        },
    };
};
exports.usePermissionsGuard = usePermissionsGuard;
//# sourceMappingURL=usePermissionsGuard.js.map